import { Send } from "lucide-react";

export function ChatComposer({ input, setInput, sending, onSend }) {
  return (
    <form onSubmit={onSend} className="p-3 border-t border-white/8 flex items-center gap-2">
      <input
        data-testid="chat-input"
        value={input}
        onChange={e => setInput(e.target.value)}
        placeholder="Ask about a product, shipping, testing…"
        className="flex-1 bg-transparent border border-white/12 focus:border-[color:var(--bl-blue)] outline-none px-3 py-2 text-sm text-white placeholder:text-white/30 font-mono"
      />
      <button
        type="submit"
        disabled={sending || !input.trim()}
        data-testid="chat-send"
        className="w-10 h-10 grid place-items-center bg-[color:var(--bl-blue)] text-black hover:bg-white disabled:opacity-40 transition-colors"
        aria-label="Send"
      >
        <Send size={15} />
      </button>
    </form>
  );
}
